import { uploadServiceContent } from '../../Components/api/uploadService';
import failStatus from "../../Components/utils/failStatus";
// import { failStatus } from '../../../utils/global';

// const media_keys = {
//   'article_image': 1,
//   'article_banner': 2,
//   'testimonial_media': 3,
//   'faq_category_icon': 4,
//   'course_image_web': 5,
//   'course_image_mobile': 6,
//   'course_image_mobile_cover': 7,
//   'course_image_web_cover': 8,
//   'course_image_application': 9,
//   'course_image_application_last_lesson': 10,
//   'course_image_application_cover': 11,
//   'course_video_preview': 12,
//   'course_video_ads': 13,
//   'public_page_video': 14,
//   'lesson_buyable_content': 15,
//   'profile_avatar': 16,
//   'article_video': 17,
//   'faq_video': 18,
//   'editor_media': 19,
// };


const onProgress = (callback) => (event) => {
  const value = Math.round((100 * event.loaded) / event.total);
  return callback(value);
};

export const uplaodFileFrom = ({file} , callback = false) => async (
  dispatch,
  getState,
) => {

  let formData = new FormData();
  formData.append('file', file);

  const uploadedFile = await uploadServiceContent(
    formData,
    '/upload',
  );
  if (failStatus(uploadedFile.data, dispatch)) return '';
  return callback && callback(uploadedFile.data.data);
};
